// extracted by mini-css-extract-plugin
export var contextualStoreBackgroundDark = "#1a1b1e";
export var getStartedButton = "PartnerLandingPage-module__getStartedButton___lIpYr";
export var hero = "PartnerLandingPage-module__hero___miP2Q";
export var heroBlur = "PartnerLandingPage-module__heroBlur___fY5R3";
export var heroContent = "PartnerLandingPage-module__heroContent___0cZ7K";
export var heroDescription = "PartnerLandingPage-module__heroDescription___Jy8nm";
export var heroImage = "PartnerLandingPage-module__heroImage___z7Fao";
export var heroImageFilters = "PartnerLandingPage-module__heroImageFilters___Dfotw";
export var heroMedia = "PartnerLandingPage-module__heroMedia___W8Kqv";
export var heroTitle = "PartnerLandingPage-module__heroTitle___xkXdr";
export var pageContainer = "PartnerLandingPage-module__pageContainer___PhBs5";
export var partnerAccentGreen = "#228648";
export var partnerAccentGreenDisabled = "rgba(34, 134, 72, 0.4)";
export var partnerAccentGreenPressed = "rgba(34, 134, 72, 0.6)";
export var partnerLinkGlyphHover = "#A8DEB6";
export var partnerLinkGlyphInactive = "rgba(113, 187, 136, 0.4)";
export var partnerLinkGlyphPressed = "rgba(168, 222, 182, 0.8)";
export var partnerLinkGlyphRest = "#71BB88";